import Swiper from 'swiper';
import { A11y, Keyboard, Mousewheel, Pagination } from 'swiper/modules';
import { decorateCarouselPagination, syncNonLoopCarouselNavState, updateCarouselLiveRegion } from './utils/lvzCarouselA11y';
import { initLvzPlyrDelegation } from './lvzPlyr';

(function initLvzPreparationVideos() {
	function initOne(root) {
		if (root.getAttribute('data-lvz-preparation-videos-init') === 'true') {
			return;
		}

		if (root.getAttribute('data-renderable') !== 'true') {
			root.setAttribute('data-lvz-preparation-videos-init', 'true');
			return;
		}

		const swiperEl = root.querySelector('[data-lvz-preparation-videos-swiper="true"]');
		if (!swiperEl) {
			return;
		}

		const slideCount = parseInt(root.getAttribute('data-slide-count'), 10);
		if (Number.isNaN(slideCount) || slideCount < 2) {
			return;
		}

		const desktopCarousel = root.getAttribute('data-desktop-carousel') === 'true';
		const mobileCarousel = root.getAttribute('data-mobile-carousel') === 'true';
		const paginationPattern = root.getAttribute('data-dot-label-pattern') || 'Video {0} of {1}';
		const livePattern = root.getAttribute('data-live-label-pattern') || paginationPattern;
		const prevButton = swiperEl.querySelector('.lvz-preparation-videos__nav--prev');
		const nextButton = swiperEl.querySelector('.lvz-preparation-videos__nav--next');
		const paginationEl = swiperEl.querySelector('.lvz-preparation-videos__pagination');
		const liveEl = root.querySelector('.lvz-preparation-videos__live');
		const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;

		const swiper = new Swiper(swiperEl, {
			modules: [Pagination, A11y, Keyboard, Mousewheel],
			loop: false,
			speed: reduceMotion ? 0 : 300,
			slidesPerView: 'auto',
			spaceBetween: 12,
			slidesOffsetBefore: 24,
			slidesOffsetAfter: 24,
			allowTouchMove: mobileCarousel,
			centerInsufficientSlides: !mobileCarousel,
			watchOverflow: true,
			grabCursor: mobileCarousel,
			observer: true,
			observeParents: true,
			a11y: {
				enabled: true,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			mousewheel: {
				enabled: true,
				forceToAxis: true,
				releaseOnEdges: true,
			},
			pagination: paginationEl
				? {
						el: paginationEl,
						clickable: true,
						enabled: mobileCarousel,
				  }
				: undefined,

			breakpoints: {
				1025: {
					slidesPerView: 'auto',
					spaceBetween: 24,
					slidesOffsetBefore: desktopCarousel ? 80 : 0,
					slidesOffsetAfter: desktopCarousel ? 80 : 0,
					allowTouchMove: desktopCarousel,
					grabCursor: desktopCarousel,
					centerInsufficientSlides: !desktopCarousel,
					pagination: { enabled: desktopCarousel },
				},
			},
			on: {
				init: function onInit(sw) {
					decorateCarouselPagination(root, '.lvz-preparation-videos__pagination', paginationPattern, slideCount);
					updateCarouselLiveRegion(liveEl, livePattern, sw.activeIndex, slideCount);
					syncNonLoopCarouselNavState(sw, prevButton, nextButton);
				},
				slideChange: function onSlideChange(sw) {
					updateCarouselLiveRegion(liveEl, livePattern, sw.activeIndex, slideCount);
					syncNonLoopCarouselNavState(sw, prevButton, nextButton);
				},
				reachBeginning: function onReachBeginning(sw) {
					syncNonLoopCarouselNavState(sw, prevButton, nextButton);
				},
				reachEnd: function onReachEnd(sw) {
					syncNonLoopCarouselNavState(sw, prevButton, nextButton);
				},
				fromEdge: function onFromEdge(sw) {
					syncNonLoopCarouselNavState(sw, prevButton, nextButton);
				},
				breakpoint: function onBreakpoint(sw) {
					decorateCarouselPagination(root, '.lvz-preparation-videos__pagination', paginationPattern, slideCount);
					syncNonLoopCarouselNavState(sw, prevButton, nextButton);
				},
			},
		});

		root.setAttribute('data-lvz-preparation-videos-init', 'true');

		requestAnimationFrame(function () {
			swiper.update();
			syncNonLoopCarouselNavState(swiper, prevButton, nextButton);
		});

		window.addEventListener(
			'resize',
			function onResize() {
				swiper.update();
				syncNonLoopCarouselNavState(swiper, prevButton, nextButton);
			},
			{ passive: true }
		);
	}

	function boot() {
		initLvzPlyrDelegation({
			sourceSelector: '.lvz-preparation-videos__card[data-video-url]',
			plyrOptions: {
				autoplay: false
			}
		});

		document.querySelectorAll('[data-lvz-preparation-videos]').forEach(function (root) {
			initOne(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
